import { createContext } from "react";

const MobileNavStateContext = createContext();

export default MobileNavStateContext